module.exports = __webpack_public_path__ + "img/ic-dropdown-ipm.48a8b39b.svg";